import axios from 'axios';
import {
	SEARCH_FAILED,
	SEARCH_FULFILLED,
	SEARH_PENDING,
	SET_SEARCHMODAL_STATE_FULFILLED,
} from '../constants/actions/searchActions';
import { DO_SEARCH } from '../constants/paths/api';

export const searchPending = () => ({
	type: SEARH_PENDING,
	payload: null,
});

export const searchFulfilled = searchResults => ({
	type: SEARCH_FULFILLED,
	payload: {
		searchResults,
	},
});

export const searchFailed = error => ({
	type: SEARCH_FAILED,
	payload: {
		error,
	},
});

export const setSearchModalState = (open: boolean) => ({
	type: SET_SEARCHMODAL_STATE_FULFILLED,
	payload: {
		searchModalIsOpen: open,
	},
});

export const search = (query: string, lang: string, subCategory = '') => {
	return async dispatch => {
		dispatch(searchPending());
		try {
			const response = await axios(
				`${DO_SEARCH}?query=${query}&lang=${lang}${subCategory ? `&subCategory=${subCategory}` : ''}`
			);
			dispatch(searchFulfilled(response.data));
		} catch (error) {
			dispatch(searchFailed(error));
		}
	};
};
